/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Test_Tap_ConfirmedInputs */

const th_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณแตะการแจ้งเตือนทดสอบแล้วและเปิดแอปได้สำเร็จ ทั้งการส่งและการเปิดใช้งานได้บนอุปกรณ์นี้`)
};

const en_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You tapped a test notification and it reached the app. Delivery and opening both work on this device.`)
};

const ja_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テスト通知をタップしてアプリが開きました。この端末では配信もタップも正しく動いています。`)
};

const zh_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你点按了一条测试通知，它抵达了应用。这台设备上的发送与打开都正常。`)
};

const es_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has tocado una notificación de prueba y ha llegado a la aplicación. La entrega y la apertura funcionan en este dispositivo.`)
};

const pt_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você tocou em uma notificação de teste e ela chegou ao aplicativo. A entrega e a abertura funcionam neste dispositivo.`)
};

const id_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda mengetuk notifikasi uji dan notifikasi itu sampai ke aplikasi. Pengiriman dan pembukaan bekerja di perangkat ini.`)
};

const fr_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez touché une notification de test et elle a atteint l’application. La remise et l’ouverture fonctionnent sur cet appareil.`)
};

const tl_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinindot mo ang pansubok na notipikasyon at nakarating ito sa app. Gumagana ang paghahatid at pagbukas sa device na ito.`)
};

const vi_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn đã chạm một thông báo thử và nó tới được ứng dụng. Việc gửi và mở đều chạy trên thiết bị này.`)
};

const ko_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`테스트 알림을 눌렀고 앱까지 도달했습니다. 이 기기에서 전송과 열기가 모두 작동합니다.`)
};

const de_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast eine Testbenachrichtigung angetippt und sie hat die App erreicht. Zustellung und Öffnen funktionieren auf diesem Gerät.`)
};

const ru_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы нажали тестовое уведомление, и оно дошло до приложения. Доставка и открытие на этом устройстве работают.`)
};

const tr_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir test bildirimine dokundunuz ve uygulamaya ulaştı. Bu cihazda gönderim ve açma çalışıyor.`)
};

const it_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai toccato una notifica di prova ed è arrivata all'app. Su questo dispositivo consegna e apertura funzionano.`)
};

const pl_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dotknąłeś powiadomienia testowego i dotarło ono do aplikacji. Dostarczanie i otwieranie działają na tym urządzeniu.`)
};

const uk_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви натиснули тестове сповіщення, і воно дійшло до застосунку. Доставка й відкриття на цьому пристрої працюють.`)
};

const hi_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपने एक परीक्षण सूचना दबाई और वह ऐप तक पहुँची। इस उपकरण पर भेजना और खोलना दोनों काम करते हैं।`)
};

const ar_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ضغطت إشعارًا تجريبيًا فوصل إلى التطبيق. الإرسال والفتح يعملان على هذا الجهاز.`)
};

const ms_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda mengetik pemberitahuan ujian dan ia sampai ke aplikasi. Penghantaran dan pembukaan berfungsi pada peranti ini.`)
};

const bn_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি একটি পরীক্ষামূলক বিজ্ঞপ্তিতে চাপ দিয়েছেন এবং তা অ্যাপে পৌঁছেছে। এই যন্ত্রে পাঠানো ও খোলা দুটোই কাজ করে।`)
};

const zh_tw2_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你點了一則測試通知，而它抵達了應用程式。這台裝置上的傳送與開啟都正常。`)
};

const zh_hk2_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你點了一則測試通知，而它抵達了應用程式。這台裝置上的傳送與開啟都正常。`)
};

const ur_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ نے ایک آزمائشی اطلاع دبائی اور وہ ایپ تک پہنچی۔ اس آلے پر بھیجنا اور کھولنا دونوں کام کرتے ہیں۔`)
};

const fa_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شما اعلان آزمایشی را زدید و به برنامه رسید. فرستادن و باز کردن روی این دستگاه کار می‌کند.`)
};

const sw_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uligusa arifa ya majaribio nayo ikafika kwenye programu. Kutuma na kufungua kunafanya kazi kwenye kifaa hiki.`)
};

const nl_test_tap_confirmed = /** @type {(inputs: Test_Tap_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt op een testmelding getikt en die kwam aan bij de app. Bezorgen en openen werken op dit apparaat.`)
};

/**
* | output |
* | --- |
* | "You tapped a test notification and it reached the app. Delivery and opening both work on this device." |
*
* @param {Test_Tap_ConfirmedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const test_tap_confirmed = /** @type {((inputs?: Test_Tap_ConfirmedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Test_Tap_ConfirmedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_test_tap_confirmed(inputs)
	if (locale === "ja") return ja_test_tap_confirmed(inputs)
	if (locale === "zh") return zh_test_tap_confirmed(inputs)
	if (locale === "es") return es_test_tap_confirmed(inputs)
	if (locale === "pt") return pt_test_tap_confirmed(inputs)
	if (locale === "id") return id_test_tap_confirmed(inputs)
	if (locale === "fr") return fr_test_tap_confirmed(inputs)
	if (locale === "tl") return tl_test_tap_confirmed(inputs)
	if (locale === "vi") return vi_test_tap_confirmed(inputs)
	if (locale === "ko") return ko_test_tap_confirmed(inputs)
	if (locale === "de") return de_test_tap_confirmed(inputs)
	if (locale === "ru") return ru_test_tap_confirmed(inputs)
	if (locale === "tr") return tr_test_tap_confirmed(inputs)
	if (locale === "it") return it_test_tap_confirmed(inputs)
	if (locale === "pl") return pl_test_tap_confirmed(inputs)
	if (locale === "uk") return uk_test_tap_confirmed(inputs)
	if (locale === "hi") return hi_test_tap_confirmed(inputs)
	if (locale === "ar") return ar_test_tap_confirmed(inputs)
	if (locale === "ms") return ms_test_tap_confirmed(inputs)
	if (locale === "bn") return bn_test_tap_confirmed(inputs)
	if (locale === "zh-TW") return zh_tw2_test_tap_confirmed(inputs)
	if (locale === "zh-HK") return zh_hk2_test_tap_confirmed(inputs)
	if (locale === "ur") return ur_test_tap_confirmed(inputs)
	if (locale === "fa") return fa_test_tap_confirmed(inputs)
	if (locale === "sw") return sw_test_tap_confirmed(inputs)
	if (locale === "nl") return nl_test_tap_confirmed(inputs)
	return en_test_tap_confirmed(inputs)
});